import { initialState } from './index';
import { RootState } from '../../../root-saga/root-state';
import { createSelector } from '@reduxjs/toolkit';

const selectDomain = (state: RootState) => state['admin'] || initialState;

export const selectIsSidebarOpen = createSelector([selectDomain], (state) => state.isSidebarOpen);
export const selectCurrentUser = createSelector([selectDomain], (state) => state.currentUser);
export const selectIsCurrentUserLoading = createSelector([selectDomain], (state) => state.isCurrentUserLoading);
export const selectIsLogoutInProgress = createSelector([selectDomain], (state) => state.isLogoutInProgress);
export const selectIsAuthenticated = createSelector([selectDomain], (state) => state.isAuthenticated);
export const selectSelectedSessionIsdToView = createSelector([selectDomain], (state) => state.selectedSessionIsdToView);
export const selectSessionTimelineItems = createSelector([selectDomain], (state) => state.sessionTimelineItems);
export const selectIsSessionTimelineLoading = createSelector([selectDomain], (state) => state.isSessionTimelineLoading);
export const selectSelectedUserToView = createSelector([selectDomain], (state) => state.selectedUserToView);
export const selectUserSessions = createSelector([selectDomain], (state) => state.userSessions);
export const selectIsUserSessionsLoading = createSelector([selectDomain], (state) => state.isUserSessionsLoading);